import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { Delete as DeleteIcon, Send as SendIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-final-form";

import { Select, TextField } from "../common/Fields";
import { Content } from "../layout";
import {
  getWorker,
  submitWorker,
  updateWorker,
  deleteWorker,
  fetchApplications,
  fetchWorkerLanguages,
} from "../../actions";

const WorkerForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const applicationRef = useRef([]);
  const { id } = useParams();

  // const [OrganizationId, setOrganizationId] = useState("");
  // const [ApplicationId, setApplicationId] = useState("");

  const { user } = useSelector((state) => state.auth);
  const { worker, languages } = useSelector((state) => state.worker);
  // const organizations = useSelector((state) => state.org.organizations.rows);
  const applications = useSelector(
    (state) => state.application.applications.rows
  );

  useEffect(() => {
    dispatch(fetchWorkerLanguages());
    if (id) {
      dispatch(getWorker(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(fetchApplications({ page: null, limit: null }));
    }
  }, [user, dispatch]);

  useEffect(() => {
    console.log("applicationRef", applicationRef.current);
  }, [applicationRef]);
  // useEffect(() => {
  //   if (id && user && applications) {
  //     navigate("/workers");
  //   }
  // }, [id, user, applications, navigate]);

  const onSubmit = useCallback(
    (worker) => {
      if (id) {
        dispatch(updateWorker({ worker, id }, navigate));
      } else {
        dispatch(submitWorker({ worker }, navigate));
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteWorker({ id }, navigate));
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        phone: worker ? worker.phone : "",
        birthdate: worker ? worker.birthdate : "",
        name: worker ? worker.name : "",
        ApplicationId: worker && applications ? [worker.Application.id] : "",
        WorkerLanguageId: worker && languages ? [worker.WorkerLanguage.id] : "",
      }}
      validate={(values) => {
        const errors = {};
        if (!values.phone) {
          errors.phone = "필수";
        }
        if (!values.birthdate) {
          errors.birthdate = "필수";
        }
        if (!values.name) {
          errors.name = "필수";
        }
        if (!values.ApplicationId) {
          errors.ApplicationId = "필수";
        }
        if (!values.WorkerLanguageId) {
          errors.WorkerLanguageId = "필수";
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  작업자
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <TextField
                      // required={true}
                      variant="standard"
                      name="phone"
                      type="text"
                      label="전화번호 (숫자)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="birthdate"
                      type="text"
                      label="생년월일 (6자리)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="name"
                      type="text"
                      label="이름"
                    />
                  </Grid>
                  {user && (
                    <Grid item xs={12}>
                      <Select
                        name="ApplicationId"
                        label="소속 협력사"
                        variant="standard"
                        data={applications}
                        dataKey="id"
                        dataValue="description"
                        // initialValue={ApplicationId}
                        // inputRef={(ref) => applicationRef.current.push(ref)}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Select
                      name="WorkerLanguageId"
                      label="사용 언어"
                      variant="standard"
                      data={languages}
                      dataKey="id"
                      dataValue="language"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default WorkerForm;
